/**
 * @fileoverview Factory function for creating choice question components
 *
 * @example
 * // Usage in component:
 * import { ChoiceQuestionFactory } from './ChoiceQuestionFactory'
 *
 * <ChoiceQuestionFactory question={question} />
 */

import { ChoiceQuestion } from './Choice'
import { CustomerSatisfactionQuestion } from './CustomerSatisfactionQuestion'

/**
 * @function ChoiceQuestionFactory
 * @description Factory function for creating choice question components
 * @param {Novoic.ChoiceQuestionProps} props - The props for the component
 * @returns {JSX.Element} The ChoiceQuestionFactory component
 */
export function ChoiceQuestionFactory(props: Novoic.ChoiceQuestionProps) {
    const { question } = props.question
    switch (question.category) {
        case 'choice':
            return <ChoiceQuestion {...props} />
        case 'csat':
            return <CustomerSatisfactionQuestion {...props} />
    }
}
